import React from 'react';
import styled from "@emotion/styled";
import Button from "@material-ui/core/Button";
import colorPalette from "../../styles/theme/colorPalette";
import {makeStyles} from "@material-ui/styles";
import {convertRGB} from "../../stores/tools/commons";

const NeutralButton = ({text, subText, hexColorCode = colorPalette.primary, maxWidth = '300px', minWidth = '240px', onClick, isRadius = true, startAdornment, endAdornment, ...custom}) => {
  const useStyles = makeStyles({
    root: {
      '&:hover': {
        backgroundColor: `rgba(${convertRGB(hexColorCode)}, 0.1) !important`,
      },
    },
  })
  const classes = useStyles()

  return (
      <div css={{
        maxWidth: maxWidth,
        minWidth: minWidth,
        button: {
          position: 'relative',
          width: '100%',
          maxWidth: maxWidth,
          borderWidth: '1px',
          borderStyle: 'solid',
          borderColor: hexColorCode,
          borderRadius: isRadius ? '100px' : '4px',
        }
      }}>
        <StyledButton
            className={classes.root}
            onClick={onClick}
            {...custom}
            sx={{color: hexColorCode}}
        >
          { startAdornment && <Adornment position={'start'}>{ startAdornment }</Adornment> }
          <div css={{maxWidth: '240px', lineHeight: '1.2'}}>
            {text}
            {
              subText &&
              <>
                <br/>
                {subText}
              </>
            }
          </div>
          { endAdornment && <Adornment position={'end'}>{ endAdornment }</Adornment> }
        </StyledButton>
      </div>
  );
};

export default NeutralButton;

const Adornment = (props) => {
  const AdornmentWrapper = styled.div`
    position: absolute;
    left: ${props => props.left === 'start' ? '1rem' : 'auto'};
    right: ${props => props.right === 'end' ? '1rem' : 'auto'};
    display: flex;
    align-items: center;
    justify-content: center;
  `
  return (
      <AdornmentWrapper left={props.position} right={props.position}>
        {props.children}
      </AdornmentWrapper>
  )
}

const StyledButton = styled(Button)`
    padding: 1rem
`
